import React from 'react';
import './profile.css';
import { useEffect, useState } from "react";
import axios from 'axios';
import { useAuth } from '../../AuthContext';
import 'materialize-css/dist/css/materialize.min.css';
import 'materialize-css/dist/js/materialize.min.js';
import 'react-responsive-modal/styles.css';
import axiosInstance from "../../axiosInstance";
import { Button } from '@mui/material';





const Profile = () => {
const { user } = useAuth();
  const [loading,setLoading] = useState(true);
  const [formData,setData] = useState(null);

  useEffect(()=>{
    setLoading(true);
    console.log(user,'profile')
    
    axiosInstance.get(`/getTeacher?id=${user.id}`).then((res)=>{
      setData(res.data);
      console.log(new Date(res.data.birthDate))

    }).catch(()=>{
      
    })

  },[user])


  const handleChange=(e)=>{
    const {name,value} = e.target;
    setData((prevData)=>({
      ...prevData,
      [name]:value
     

    }))

  }

  if(!formData){
    return <div>
      loading
    </div>

  }

  const updateData =()=>{
    axiosInstance.post('/editTeacher',formData).then((res)=>{
     

    }).catch(()=>{
      console.log("error")

    })
   
  }
 
 

  return (
    <div className="profile_container">
    <form name="teacherForm" onSubmit={() => {}}>
      {/* First Row */}
      <div className="row">
        <div className="input-field">
          <input name="id" id="id" type="number" value={formData.teacherCode || ''} onChange={() => {}} />
          <label className="active">Teacher ID</label>
        </div>
        <div className="input-field">
          <input name="name" type="text" value={formData.name || ''} onChange={() => {}} />
          <label className="active">Full Name</label>
        </div>

        <div className="input-field">
          <input name="pin" type="text" value={formData.pin || ''} onChange={() => {}} />
          <label className="active">Pin</label>
        </div>
        
      </div>

      {/* Second Row */}
      <div className="row">
       
        <div className="input-field">
          <input name="pin" type="text" value={formData.pin || ''} onChange={() => {}} />
          <label className="active">Pin</label>
        </div>

        <div className="input-field">
          <input name="qualification" type="text" value={formData.qualification || ''} onChange={() => {}} />
          <label className="active">Qualification</label>
        </div>
        <div className="input-field">
          <input name="email" type="email" value={formData.email || ''} onChange={handleChange} />
          <label className="active">Email</label>
        </div>
      </div>

    

      <div className="row">
    
        <div className="input-field">
          <input name="birthDate" type="date" value={formData.birthDate || ''} onChange={() => {}} />
          <label className="active">Birth Date</label>
        </div>
        <div className="input-field">
          <input name="mobileNo" type="text" value={formData.mobileNo || ''} onChange={handleChange} />
          <label className="active">Mobile No</label>
        </div>
      </div>

      {/* Fifth Row */}
      <div className="row">
        <div className="input-field">
          <input name="address" type="text" value={formData.address || ''} onChange={() => {}} />
          <label className="active">Address</label>
        </div>
        <div className="input-field">
          <input name="trainer" type="text" value={formData.trainerTeacherName || ''} onChange={() => {}} />
          <label className="active">Trainer Teacher</label>
        </div>
      </div>

      <div className='row action'>
        <Button className='update'onClick={updateData}>Update</Button>

      </div>
    </form>
</div>

  );
};

export default Profile;
